import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import CustomFieldDefinitionDto from '@/features/dashboard/tourCustomFields/types/_CustomFieldDefinitionDto.ts';

const tourParticipantCustomFieldsApi = {
  createField: async (
    tourId: string,
    customFieldDef: Omit<CustomFieldDefinitionDto, 'id' | 'orderIndex'>,
  ): Promise<void> => {
    await fetchPrivateApi(
      'POST',
      `tours/${tourId}/participant-form/fields`,
      customFieldDef,
    );
  },
  updateField: async (
    tourId: string,
    fieldId: string,
    customFieldDef: CustomFieldDefinitionDto,
  ): Promise<void> => {
    await fetchPrivateApi(
      'PUT',
      `tours/${tourId}/participant-form/fields/${fieldId}`,
      customFieldDef,
    );
  },
  deleteField: async (tourId: string, fieldId: string): Promise<void> => {
    await fetchPrivateApi(
      'DELETE',
      `tours/${tourId}/participant-form/fields/${fieldId}`,
    );
  },
  getAllFieldsForTour: async (
    tourId: string,
  ): Promise<CustomFieldDefinitionDto[]> => {
    return await fetchPrivateApi<CustomFieldDefinitionDto[]>(
      'GET',
      `tours/${tourId}/participant-form/fields`,
    );
  },
  reorderFields: async (tourId: string, fieldIds: string[]): Promise<void> => {
    await fetchPrivateApi(
      'PUT',
      `tours/${tourId}/participant-form/fields/order`,
      fieldIds,
    );
  },
};

export default tourParticipantCustomFieldsApi;
